/**
 * @param {{
 *   isReportsActive: boolean,
 *   closeDrawer: () => void,
 *   setSelectedReport: (report: null) => void,
 *   setShowRecipients: (value: boolean) => void,
 * }} deps
 */
export function applyCloseOrganizationReportsPanelState(deps) {
    // Clear report selection even when the drawer was already closed (e.g. chatPopover
    // watcher in RightDrawer/Index.vue) so stale selectedReport/showRecipients cannot linger.
    if (deps.isReportsActive) {
        deps.closeDrawer();
    }

    deps.setSelectedReport(null);
    deps.setShowRecipients(false);
}
